import './_jquery';

jQuery(function() {
  if (window.location.pathname === '/') {
    $('.mosaic-item').on('hover', function() {
      $('.mosaic-item').not(this).each(function() {
        $(this).toggleClass('animate--opacity-50');
      });
    });
  }

  if (document.getElementsByClassName('home__header--01a')[0]) {
    setTimeout(function() {
      document.getElementsByClassName('component_video--embed')[0].dataset.loaded = true;
    }, 2000);
  }
});
